// src/assets/images.js
import hero from "./triangulo.avif"
import image1 from "./1.png";
import image2 from "./2.png";
import image3 from "./3.png";
import image4 from "./4.png";
import image5 from "./5.png";
import image6 from "./6.png";
import image7 from "./7.png";
import image8 from "./8.png";
import image9 from "./9.png";
import image10 from "./10.png";
import image11 from "./11.png";
import image12 from "./12.png";
import image13 from "./13.png";
import image14 from "./14.png";
import image15 from "./15.png";
import image16 from  "./16.png";
import image17 from  "./17.png";
import image18 from  "./18.png";
import image19 from  "./19.png";
import image20 from  "./20.png";
import image21 from  "./21.png";
import image22 from  "./22.png";
import image23 from  "./23.png";
import image24 from  "./24.png";
import image25 from  "./25.png";
import image26 from  "./26.png";
import image27 from  "./27.png";
import image28 from  "./28.png";
import image29 from  "./29.png";
import image30 from  "./30.png";
import image31 from  "./31.png";
import image32 from  "./32.png";
import image33 from  "./33.png";
import image34 from  "./34.png";
import image35 from  "./35.png";
import image36 from  "./36.png";
import image37 from  "./37.png";
import image38 from  "./38.png";
import image39 from  "./39.png";
import image40 from  "./40.png";
import image41 from  "./41.png";
import image42 from  "./42.png";
import image43 from  "./43.png";
import image44 from  "./44.png";
import image45 from  "./45.png";
import image46 from  "./46.png";
import image47 from  "./47.png";
import image48 from  "./48.png";
import image49 from  "./49.png";
import image50 from  "./50.png";
import image51 from  "./51.png";
import image52 from  "./52.png";
import image53 from  "./53.png";
import image54 from  "./54.png";
import image55 from  "./55.png";
import image56 from  "./56.png";
import image57 from  "./57.png";
import image58 from  "./58.png";
import image59 from  "./59.png";
import image60 from  "./60.png";
import image61 from  "./61.png";
import image62 from "./62.png";
import image63 from "./63.png";
import image64 from "./64.png";
import image65 from "./65.png";
import image66 from "./66.png";
import image67 from "./67.png";
import image68 from "./68.png";
import image69 from "./69.png";
import image70 from "./70.png";
import image71 from "./71.png";
import image72 from "./72.png";
import image73 from "./73.png";
import image74 from "./74.png";
import image75 from "./75.png";
import image76 from "./76.png";
import image77 from "./77.png";
import image78 from "./78.png";
import image79 from "./79.png";
import image80 from "./80.png";
import image81 from "./81.png";
import image82 from "./82.png";
import image83 from "./83.png";
import image84 from "./84.png";
import image85 from "./85.png";
import image86 from "./86.png";
import image87 from "./87.png";
import image88 from "./88.png";
import image89 from "./89.png";
import image90 from "./90.png";
import image91 from "./91.png";
import image92 from "./92.png";
import image93 from "./93.png";
import image94 from "./94.png";
import image95 from "./95.png";
import image96 from "./96.png";
import image97 from "./97.png";
import image98 from "./98.png";
import image99 from "./99.png";
import image100 from "./100.png";
import image101 from "./101.png";
import image102 from "./102.png";
import image103 from "./103.png";
import image104 from "./104.png";
import image105 from "./105.png";
import image106 from "./106.png";
import image107 from "./107.png";
import image108 from "./108.png";
import image109 from "./109.png";
import image110 from "./110.png";
import image111 from "./111.png";
import image112 from "./112.png";
import image113 from "./113.png";
import image114 from "./114.png";
import image115 from "./115.png";
import image116 from "./116.png";
import image117 from "./117.png";
import image118 from "./118.png";
import image119 from "./119.png";
import image120 from "./120.png";
import image121 from "./121.png";
import image122 from "./122.png";
import image123 from "./123.png";
import image124 from "./124.png";
import image125 from "./125.png";
import image126 from "./126.png";
import image127 from "./127.png";
import image128 from "./128.png";
import image129 from "./129.png";
import image130 from "./130.png";
import image131 from "./131.png";
import image132 from "./132.png";
import image133 from "./133.png";
import image134 from "./134.png";
import image135 from "./135.png";
import image136 from "./136.png";
import image137 from "./137.png";
import image138 from "./138.png";
import image139 from "./139.png";
import image140 from "./140.png";
import image141 from "./141.png";
import image142 from "./142.png";
import image143 from "./143.png";
import image144 from "./144.png";
import image145 from "./145.png";
import image146 from "./146.png";
import image147 from "./147.png";
import image148 from "./148.png";
import image149 from "./149.png";
import image150 from "./150.png";
import image151 from "./151.png";
import image152 from "./152.png";
import image153 from "./153.png";
import image154 from "./154.png";
import image155 from "./155.png";
import image156 from "./156.png";
import image157 from "./157.png";
import image158 from "./158.png";
import image159 from "./159.png";
import image160 from "./160.png";
import image161 from "./161.png";
import image162 from "./162.png";
import image163 from "./163.png";
import image164 from "./164.png";
import image165 from "./165.png";
import image166 from "./166.png";
import image167 from "./167.png";
import image168 from "./168.png";
import image169 from "./169.png";
import image170 from "./170.png";
import image171 from "./171.png";
import image172 from "./172.png";
import image173 from "./173.png";
import image174 from "./174.png";
import image175 from "./175.png";
import image176 from "./176.png";
import image177 from "./177.png";
import image178 from "./178.png";
import image179 from "./179.png";
import image180 from "./180.png";
import image181 from "./181.png";
import image182 from "./182.png";
import image183 from "./183.png";
import image184 from "./184.png";
import image185 from "./185.png";
import image186 from "./186.png";
import image187 from "./187.png";
import image188 from "./188.png";
import image189 from "./189.png";
import image190 from "./190.png";
import image191 from "./191.png";
import image192 from "./192.png";
import image193 from "./193.png";
import image194 from "./194.png";
import image195 from "./195.png";
import image196 from "./196.png";
import image197 from "./197.png";
import image198 from "./198.png";
import image199 from "./199.png";
import image200 from "./200.png";
import image201 from "./201.png";
import image202 from "./202.png";
import image203 from "./203.png";
import image204 from "./204.png";
import image205 from "./205.png";
import image206 from "./206.png";
import image207 from "./207.png";
import image208 from "./208.png";
import image209 from "./209.png";
import image210 from "./210.png";
import image211 from "./211.png";
import image212 from "./212.png";
import image213 from "./213.png";
import image214 from "./214.png";
import image215 from "./215.png";
import image216 from "./216.png";
import image217 from "./217.png";
import image218 from "./218.png";
import image219 from "./219.png";
import image220 from "./220.png";
import image221 from "./221.png";
import image222 from "./222.png";
import image223 from "./223.png";
import image224 from "./224.png";
import image225 from "./225.png";
import image226 from "./226.png";
import image227 from "./227.png";
import image228 from "./228.png";
import image229 from "./229.png";
import image230 from "./230.png";
import image231 from "./231.png";
import image232 from "./232.png";
import image233 from "./233.png";
import image234 from "./234.png";
import image235 from "./235.png";
import image236 from "./236.png";
import image237 from "./237.png";
import image238 from "./238.png";
import image239 from "./239.png";
import image240 from "./240.png";
import image241 from "./241.png";
import image242 from "./242.png";
import image243 from "./243.png";
import image244 from "./244.png";
import image245 from "./245.png";
import image246 from "./246.png";
import image247 from "./247.png";
import image248 from "./248.png";
import image249 from "./249.png";
import image250 from "./250.png";
import image251 from "./251.png";
import image252 from "./252.png";
import image253 from "./253.png";
import image254 from "./254.png";
import image255 from "./255.png";
import image256 from "./256.png";
import image257 from "./257.png";
import image258 from "./258.png";
import image259 from "./259.png";
import image260 from "./260.png";
import image261 from "./261.png";
import image262 from "./262.png";
import image263 from "./263.png";
import image264 from "./264.png";
import image265 from "./265.png";
import image266 from "./266.png";
import image267 from "./267.png";
import image268 from "./268.png";
import image269 from "./269.png";
import image270 from "./270.png";
import image271 from "./271.png";
import image272 from "./272.png";
import image273 from "./273.png";
import image274 from "./274.png";
import image275 from "./275.png";
import image276 from "./276.png";
import image277 from "./277.png";
import image278 from "./278.png";
import image279 from "./279.png";
import image280 from "./280.png";
import image281 from "./281.png";
import image282 from "./282.png";
import image283 from "./283.png";
import image284 from "./284.png";
import image285 from "./285.png";
import image286 from "./286.png";
import image287 from "./287.png";
import image288 from "./288.png";
import image289 from "./289.png";
import image290 from "./290.png";
import image291 from "./291.png";
import image292 from "./292.png";
import image293 from "./293.png";
import image294 from "./294.png";
import image295 from "./295.png";
import image296 from "./296.png";
import image297 from "./297.png";
import image298 from "./298.png";
import image299 from "./299.png";
import image300 from "./300.png";
import image301 from "./301.png";
import image302 from "./302.png";
import image303 from "./303.png";
import image304 from "./304.png";
import image305 from "./305.png";
import image306 from "./306.png";
import image307 from "./307.png";
import image308 from "./308.png";
import image309 from "./309.png";
import image310 from "./310.png";
import image311 from "./311.png";
import image312 from "./312.png";
import image313 from "./313.png";
import image314 from "./314.png";
import image315 from "./315.png";
import image316 from "./316.png";
import image317 from "./317.png";
import image318 from "./318.png";
import image319 from "./319.png";
import image320 from "./320.png";
import image321 from "./321.png";
import image322 from "./322.png";
import image323 from "./323.png";
import image324 from "./324.png";
import image325 from "./325.png";
import image326 from "./326.png";
import image327 from "./327.png";
import image328 from "./328.png";
import image329 from "./329.png";
import image330 from "./330.png";
import image331 from "./331.png";
import image332 from "./332.png";
import image333 from "./333.png";
import image334 from "./334.png";
import image335 from "./335.png";
import image336 from "./336.png";
import image337 from "./337.png";
import image338 from "./338.png";
import image339 from "./339.png";
import image340 from "./340.png";
import image341 from "./341.png";
import image342 from "./342.png";
import image343 from "./343.png";
import image344 from "./344.png";
import image345 from "./345.png";
import image346 from "./346.png";
import image347 from "./347.png";
import image348 from "./348.png";
import image349 from "./349.png";
import image350 from "./350.png";
import image351 from "./351.png";
import image352 from "./352.png";
import image353 from "./353.png";
import image354 from "./354.png";
import image355 from "./355.png";
import image356 from "./356.png";
import image357 from "./357.png";
import image358 from "./358.png";
import image359 from "./359.png";
import image360 from "./360.png";
import image361 from "./361.png";
import image362 from "./362.png";
import image363 from "./363.png";
import image364 from "./364.png";
import image365 from "./365.png";
import image366 from "./366.png";
import image367 from "./367.png";
import image368 from "./368.png";










const images = {
    hero,
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image25,
  image26,
  image27,
  image28,
  image29,
  image30,
  image31,
  image32,
  image33,
  image34,
  image35,
  image36,
  image37,
  image38,
  image39,
  image40,
  image41,
  image42,
  image43,
  image44,
  image45,
  image46,
  image47,
  image48,
  image49,
  image50,
  image51,
  image52,
  image53,
  image54,
  image55,
  image56,
  image57,
  image58,
  image59,
  image60,
  image61,
  image62,
  image63,
  image64,
  image65,
  image66,
  image67,
  image68,
  image69,
  image70,
  image71,
  image72,
  image73,
  image74,
  image75,
  image76,
  image77,
  image78,
  image79,
  image80,
  image81,
  image82,
  image83,
  image84,
  image85,
  image86,
  image87,
  image88,
  image89,
  image90,
  image91,
  image92,
  image93,
  image94,
  image95,
  image96,
  image97,
  image98,
  image99,
  image100,
  image101,
  image102,
  image103,
  image104,
  image105,
  image106,
  image107,
  image108,
  image109,
  image110,
  image111,
  image112,
  image113,
  image114,
  image115,
  image116,
  image117,
  image118,
  image119,
  image120,
  image121,
  image122,
  image123,
  image124,
  image125,
  image126,
  image127,
  image128,
  image129,
  image130,
  image131,
  image132,
  image133,
  image134,
  image135,
  image136,
  image137,
  image138,
  image139,
  image140,
  image141,
  image142,
  image143,
  image144,
  image145,
  image146,
  image147,
  image148,
  image149,
  image150,
  image151,
  image152,
  image153,
  image154,
  image155,
  image156,
  image157,
  image158,
  image159,
  image160,
  image161,
  image162,
  image163,
  image164,
  image165,
  image166,
  image167,
  image168,
  image169,
  image170,
  image171,
  image172,
  image173,
  image174,
  image175,
  image176,
  image177,
  image178,
  image179,
  image180,
  image181,
  image182,
  image183,
  image184,
  image185,
  image186,
  image187,
  image188,
  image189,
  image190,
  image191,
  image192,
  image193,
  image194,
  image195,
  image196,
  image197,
  image198,
  image199,
  image200,
  image201,
  image202,
  image203,
  image204,
  image205,
  image206,
  image207,
  image208,
  image209,
  image210,
  image211,
  image212,
  image213,
  image214,
  image215,
  image216,
  image217,
  image218,
  image219,
  image220,
  image221,
  image222,
  image223,
  image224,
  image225,
  image226,
  image227,
  image228,
  image229,
  image230,
  image231,
  image232,
  image233,
  image234,
  image235,
  image236,
  image237,
  image238,
  image239,
  image240,
  image241,
  image242,
  image243,
  image244,
  image245,
  image246,
  image247,
  image248,
  image249,
  image250,
  image251,
  image252,
  image253,
  image254,
  image255,
  image256,
  image257,
  image258,
  image259,
  image260,
  image261,
  image262,
  image263,
  image264,
  image265,
  image266,
  image267,
  image268,
  image269,
  image270,
  image271,
  image272,
  image273,
  image274,
  image275,
  image276,
  image277,
  image278,
  image279,
  image280,
  image281,
  image282,
  image283,
  image284,
  image285,
  image286,
  image287,
  image288,
  image289,
  image290,
  image291,
  image292,
  image293,
  image294,
  image295,
  image296,
  image297,
  image298,
  image299,
  image300,
  image301,
  image302,
  image303,
  image304,
  image305,
  image306,
  image307,
  image308,
  image309,
  image310,
  image311,
  image312,
  image313,
  image314,
  image315,
  image316,
  image317,
  image318,
  image319,
  image320,
  image321,
  image322,
  image323,
  image324,
  image325,
  image326,
  image327,
  image328,
  image329,
  image330,
  image331,
  image332,
  image333,
  image334,
  image335,
  image336,
  image337,
  image338,
  image339,
  image340,
  image341,
  image342,
  image343,
  image344,
  image345,
  image346,
  image347,
  image348,
  image349,
  image350,
  image351,
  image352,
  image353,
  image354,
  image355,
  image356,
  image357,
  image358,
  image359,
  image360,
  image361,
  image362,
  image363,
  image364,
  image365,
  image366,
  image367,
  image368,

  


};

export default images;
